import TeFooter from './index.vue';


TeFooter.install = function(Vue) {
  Vue.component(TeFooter.name, TeFooter);
};

export default TeFooter;